export const FALL_WINBACK_CAMPAIGN_ID = "fall-winback-2026";
export const FALL_WINBACK_PREVIEW_PATH = "/welcome-back";
export const FALL_WINBACK_PREVIEW_DURATION_MS = 7 * 24 * 60 * 60 * 1000;
export const FALL_WINBACK_CHECKOUT_GRACE_MS = 30 * 60 * 1000;
export const FALL_WINBACK_ACCOUNT_CUTOFF_MS = Date.parse("2026-07-01T04:00:00.000Z");
export const FALL_WINBACK_ACTIVATION_DEADLINE_MS = Date.parse("2026-09-09T03:59:59.999Z");
export const FALL_WINBACK_MAILCHIMP_ACTIVATED_TAG = "fall-winback-preview-activated";
export const FALL_WINBACK_GETTING_STARTED_CLASS_ID = "getting-started";
